const progressCircle = "_arap14ml4kn";
const loader = "_aral19uvzm2";

export { loader, progressCircle };
import "./button.style.linaria.module.css";
//# sourceMappingURL=button.style.js.map
